import React from 'react';
import StyledTable from '@shared/components/StyledTable';

/**
 * @typedef {object} AppraiserAppraisalsTableProps
 * @property {Array<*>} [appraisals]
 * @property {number} [totalAppraisalsCount]
 * @property {(event: React.MouseEvent, id: number) => void} [handleAssignClick]
 * @property {(event: React.MouseEvent, id: number) => void} [handleOpenConfirmDialog]
 * @property {(offset: number) => void} [handlePageChange]
 * @property {number} [pageSize]
 * @property {number} [currentPage]
 * @property {boolean} [loading]
 */

/**
 * @param {AppraiserAppraisalsTableProps} props
 */
const AppraiserAppraisalsTable = props => {
  const {
    handleAssignClick,
    handleOpenConfirmDialog,
    loading,
    currentPage,
    appraisals = [],
    totalAppraisalsCount = 0,
    handlePageChange = () => {},
    pageSize = 10
  } = props;

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: '15%',
      render: text => text
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '25%',
      render: text => text
    },
    {
      title: 'Unit(s)',
      dataIndex: 'orgUnitNames',
      width: '45%',
      render: text => text
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '15%',
      render: (_, record) => {
        if (record.action == ACTION_TYPE.ASSIGN) {
          return (
            <a href='#' onClick={e => handleAssignClick(e, record.id)}>
              Assign
            </a>
          );
        }
        if (record.action == ACTION_TYPE.UNASSIGN) {
          return (
            <a href='#' onClick={e => handleOpenConfirmDialog(e, record.id)}>
              Unassign
            </a>
          );
        }
      }
    }
  ];

  const handlePageChangeInner = pagination => {
    const offset = pagination.current * pagination.pageSize - pagination.pageSize;

    handlePageChange(offset);
  };

  return (
    <StyledTable
      className='event-team-table'
      columns={columns}
      dataSource={appraisals}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: totalAppraisalsCount,
        hideOnSinglePage: true,
        showSizeChanger: false
      }}
      onChange={handlePageChangeInner}
      showSorterTooltip={false}
      loading={loading}
    />
  );
};

const ACTION_TYPE = {
  ASSIGN: 'assign',
  UNASSIGN: 'unassign'
};

export default AppraiserAppraisalsTable;
